import { Injectable } from '@angular/core';
import { FilterModel } from '../../../../core/models/filters/filters.model';
import { SortModel } from '../../../../core/models/filters/sort.model';
import { Observable } from 'rxjs';
import { HeaderHelperService } from '../../../../core/services/header-helper.service';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class TableService {

  constructor(private http: HttpClient, private headerHelperService: HeaderHelperService, private translate: TranslateService) { }

  getList(
    page: number,
    size: number,
    url: string,
    type: string,
    filters?: FilterModel[],
    sort?: SortModel,
  ): Observable<any> {
    console.log(type);
    let urlList = `${url}?PageRequest.PageIndex=${page - 1
      }&PageRequest.PageSize=${size}`;

    if (filters) {
      const resultFilter = filters.filter((x) => !!x.value);
      urlList += resultFilter.map((f) => `&${f.filterId}=${f.value}`).join('');
    }
    if (sort && type) {
      urlList += `&SortBy=${this.getSortByValue(sort.column, type)}&SortDescending=${sort.orderBy == 'descending'
        }`;
    }

    return this.http.get<any>(urlList, {
      headers: this.headerHelperService.getHeaders(),
    });
  }


  getSortByValue(column: string, type: string): string {
    switch (type) {
      case "userList":
        switch (column) {
          case 'pidNo':
            return 'Patient.PidNo';
          case 'nameAndSurname':
            return 'Name';
          case 'patientStatus':
            return 'PatientRecordCases.PatientStatus';
          case 'createdBy':
            return 'CreatedUser';
          case 'roleName':
            return 'Role.Name';
          default:
            return column;
        }
      case 'consultationList':
        switch (column) {
          case 'pidNo':
            return 'Patient.PidNo';
          case 'patientName':
            return 'Patient.Name';
          case 'patientStatus':
            return 'PatientRecordCases.PatientStatus';
          case 'createdBy':
            return 'CreatedUser';
          default:
            return column;
        }
      case 'invoiceList':
        switch (column) {
          case 'pidNo':
            return 'Patient.PidNo';
          case 'patientName':
            return 'Patient.Name';
          case 'patientStatus':
            return 'PatientRecordCases.PatientStatus';
          case 'createdBy':
            return 'CreatedUser';
          default:
            return column;
        }
      case 'appointmentList':
        switch (column) {
          case 'pidNo':
            return 'PatientRecord.Patient.PidNo';
          case 'nameAndSurname':
            return 'PatientRecord.Patient.Name';
          case 'customerCode':
            return 'PatientRecord.CustomerCode';
          case 'createdBy':
            return 'PatientRecord.CreatedUser';
          case 'customerBranchName':
            return 'CustomerBranchName';

          default:
            return column;
        }
      case 'referralList':
        switch (column) {
          case 'pidNo':
            return 'Patient.PidNo';
          case 'patientName':
            return 'Patient.Name';
          case 'customerCode':
            return 'CustomerCode';
          case 'createdBy':
            return 'CreatedUser';
          case 'patientStatus':
            return 'PatientRecordCases.PatientStatus';
          default:
            return column;
        }
      case 'patienList':
        switch (column) {
          case 'pidNo':
            return 'PIDNo';
          case 'nameAndSurname':
            return 'Name';
          case 'customerCode':
            return 'PatientRecord.CustomerCode';
          case 'createdBy':
            return 'CreatedUser';
          case 'patientStatus':
            return 'PatientRecord.PatientRecordCases.PatientStatus';
          default:
            return column;
        }
      case 'dermaiList':
        switch (column) {
          case 'caseId':
            return 'CaseId';
          case 'patientId':
            return 'PatientId';
          case 'patientName':
            return 'PatientName';
          case 'createdDate':
            return 'CreatedDate';
          case 'caseStatusName':
            return 'CaseStatus';
          case 'paymentStatus':
            return 'PaymentStatus';
          default:
            return column;
        }
      default:
        return column;
    }

  }
}
